<template>
  
  <div class="modal-card-body has-text-centered">
    <p v-html="verbiage.address_search_paragraph"></p>
    <b-field position="is-centered">
      <b-input
        ref="addressInput"
        @keyup.enter="search"
        v-model="inputAddress"
        placeholder="Enter your address">
      </b-input>
      <p class="control">
        <b-button @click="search" id="search-button" type="is-primary">
          <magnify-icon />
          Search
        </b-button>
      </p>
    </b-field>
  </div>    
  
</template>

<script>
import { ref, watch, onMounted, nextTick, getCurrentInstance } from 'vue'
import { useRouter } from 'vue-router'
import { useMainStore } from '@/stores/main'
import { useConfig } from '@/composables/useConfig'
import LeadWorkflowNavigationButtons from '@/components/lead_workflow_components/LeadWorkflowNavigationButtons.vue'
import { snackbarDefaults } from '../../constants'

export default {
  name: 'AddressSearch',
  components: {
    LeadWorkflowNavigationButtons
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    isFirst: {
      type: Boolean,
      default: false
    },
    isLast: {
      type: Boolean,
      default: false
    },
    nextButtonClicked: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close', 'set-title', 'set-prev-route', 'set-next-button-label', 'set-show-next'],
  setup(props, { emit }) {
    const router = useRouter()
    const mainStore = useMainStore()
    const instance = getCurrentInstance()
    const { verbiage } = useConfig()

    const addressInput = ref(null)
    const inputAddress = ref('')

    const close = () => {
      emit('close')
    }

    const search = async () => {
      if (inputAddress.value.length) {
        await mainStore.searchAddress(inputAddress.value)
        router.push(`/flow/confirm-address`)
      } else {
        instance.proxy.$buefy.snackbar.open({
          ...snackbarDefaults,
          message: `Please enter an address.`
        })
      }
    }

    watch(() => props.nextButtonClicked, (val) => {
      if (val) {
        search()
      }
    })

    onMounted(() => {
      emit('set-title', verbiage.value.address_search_title)
      nextTick(() => {
        addressInput.value.focus()
      })

      emit('set-prev-route', '/flow/introduction')
      emit('set-next-button-label', 'Search')
      emit('set-show-next', true)
    })

    return {
      addressInput,
      inputAddress,
      verbiage,
      close,
      search
    }
  }
}
</script>

<style scoped>
  #search-button {
    background-color: green;
  }

  .modal-card-body > p {
    padding-bottom: 1em;
  }
</style>